/* norsu â main menu behaviour
   --------------------------------------------------------------
   Vanilla JS port of the React prototype. Handles:
   â¢ Megamenu hover/focus open + delayed close
   â¢ Click-outside + Escape to close
   â¢ Search overlay open/close
   â¢ Mobile drawer open/close + slide-over for nested categories
   â¢ Announcement bar rotation

   No dependencies. ~6KB. Load with defer in theme.liquid.
   -------------------------------------------------------------- */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  var ran = false;
  function init() {
    if (ran) return; ran = true;
    setupAnnouncement();
    setupMegaMenu();
    setupSearch();
    setupDrawer();
  }

  /* ============================================================
     Announcement bar â rotate items at the configured interval
     ============================================================ */
  function setupAnnouncement() {
    var bar = document.querySelector('[data-rotate-ms]');
    if (!bar) return;
    var items = Array.prototype.slice.call(bar.querySelectorAll('.nv-announce__item'));
    var dots  = Array.prototype.slice.call(bar.querySelectorAll('.nv-announce__dot'));
    if (items.length < 2) return;

    var ms = parseInt(bar.getAttribute('data-rotate-ms'), 10) || 5000;
    var i  = 0;
    var timer;

    function show(idx) {
      items.forEach(function (el, n) { el.classList.toggle('is-active', n === idx); });
      dots.forEach(function (el, n) { el.classList.toggle('is-active', n === idx); });
      i = idx;
    }
    function tick() { show((i + 1) % items.length); }
    function start() { stop(); timer = setInterval(tick, ms); }
    function stop()  { if (timer) clearInterval(timer); }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-index'), 10) || 0);
        start();
      });
    });

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    start();
  }

  /* ============================================================
     Megamenu â hover/focus to open, delayed close on mouseleave
     ============================================================ */
  function setupMegaMenu() {
    var header = document.querySelector('[data-nv-header]');
    var primary = document.querySelector('[data-nv-primary]');
    if (!header || !primary) return;

    var items = Array.prototype.slice.call(primary.querySelectorAll('[data-nv-item]'));
    var closeTimer = null;
    var openItem = null;

    function clearTimer() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }

    function open(item) {
      clearTimer();
      var mega = item.querySelector('[data-nv-mega]');
      if (!mega) {
        // No children â close any existing
        if (openItem && openItem !== item) closeAll();
        return;
      }
      if (openItem === item) return;
      closeAll();
      item.classList.add('is-open');
      mega.classList.add('is-open');
      var link = item.querySelector('.nv-primary__link');
      if (link && link.hasAttribute('aria-haspopup')) link.setAttribute('aria-expanded', 'true');
      openItem = item;
    }

    function closeAll() {
      items.forEach(function (it) {
        it.classList.remove('is-open');
        var mega = it.querySelector('[data-nv-mega]');
        if (mega) mega.classList.remove('is-open');
        var link = it.querySelector('.nv-primary__link');
        if (link && link.hasAttribute('aria-haspopup')) link.setAttribute('aria-expanded', 'false');
      });
      openItem = null;
    }

    function scheduleClose() {
      clearTimer();
      closeTimer = setTimeout(closeAll, 140);
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { open(item); });
      var link = item.querySelector('.nv-primary__link');
      if (link) link.addEventListener('focus', function () { open(item); });
    });

    primary.addEventListener('mouseleave', scheduleClose);
    // Keep megamenu open when hovering the panel itself
    primary.querySelectorAll('[data-nv-mega]').forEach(function (m) {
      m.addEventListener('mouseenter', clearTimer);
    });

    // Click outside header closes
    document.addEventListener('mousedown', function (e) {
      if (!header.contains(e.target)) closeAll();
    });

    // Escape closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ============================================================
     Search overlay
     ============================================================ */
  function setupSearch() {
    var overlay = document.querySelector('[data-nv-search]');
    if (!overlay) return;
    var openBtns = document.querySelectorAll('[data-nv-search-open]');
    var closeBtn = document.querySelector('[data-nv-search-close]');
    var input    = overlay.querySelector('[data-nv-search-input]');

    function open() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function(btn) { btn.addEventListener('click', open); });
    if (closeBtn) closeBtn.addEventListener('click', close);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
  }

  /* ============================================================
     Mobile drawer â open/close + slide-over for nested levels
     ============================================================ */
  function setupDrawer() {
    var drawer = document.querySelector('[data-nv-drawer]');
    var scrim  = document.querySelector('[data-nv-scrim]');
    if (!drawer || !scrim) return;

    var openBtn  = document.querySelector('[data-nv-drawer-open]');
    var closeBtn = document.querySelector('[data-nv-drawer-close]');
    var rows     = Array.prototype.slice.call(drawer.querySelectorAll('[data-nv-drawer-row]'));
    var panels   = Array.prototype.slice.call(drawer.querySelectorAll('[data-nv-drawer-panel]'));
    var backBtns = Array.prototype.slice.call(drawer.querySelectorAll('[data-nv-drawer-back]'));

    function open() {
      drawer.classList.add('is-open');
      scrim.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      scrim.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      closePanels();
      document.body.style.overflow = '';
    }
    function openPanel(idx) {
      panels.forEach(function (p) {
        p.classList.toggle('is-open', p.getAttribute('data-nv-drawer-panel') === String(idx));
      });
    }
    function closePanels() {
      panels.forEach(function (p) { p.classList.remove('is-open'); });
    }

    if (openBtn)  openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    scrim.addEventListener('click', close);

    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        openPanel(row.getAttribute('data-nv-drawer-row'));
      });
    });
    backBtns.forEach(function (b) {
      b.addEventListener('click', closePanels);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }
})();


/* ---- Predictive Search ---- */
(function () {
  var input    = document.querySelector('[data-nv-search-input]');
  var resultsEl = document.querySelector('.nv-search-results');
  if (!input || !resultsEl) return;

  var timer = null;
  var lastQ = '';

  function debounce(fn, ms) {
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, ms);
    };
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function renderResults(data) {
    var products    = (data.resources && data.resources.results && data.resources.results.products)    || [];
    var queries     = (data.resources && data.resources.results && data.resources.results.queries)     || [];
    var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];

    // 2026-10-08: seasonal pieces first, then native results filling the rest, deduped by URL.
    // See fetchSeasonalLead below for why.
    var merged = (data.lead || []).slice();
    var seen = {};
    merged.forEach(function (p) { seen[(p.url || '').split('?')[0]] = true; });
    products.forEach(function (p) {
      var key = (p.url || '').split('?')[0];
      if (seen[key]) return;
      seen[key] = true;
      merged.push({ url: p.url, title: p.title, image: p.image, priceHtml: p.price ? '$' + p.price : '' });
    });

    if (!merged.length && !queries.length && !collections.length) {
      resultsEl.hidden = true;
      return;
    }

    var term = input.value.trim();
    var html = '<div class="nv-sr-grid">';

    html += '<div class="nv-sr-left">';
    if (queries.length) {
      html += '<div class="nv-sr-suggestions"><h4>Suggestions</h4><ul>';
      queries.slice(0, 4).forEach(function (sq) {
        html += '<li><a href="' + sq.url + '">' + sq.styled_text + '</a></li>';
      });
      html += '</ul></div>';
    }
    if (collections.length) {
      html += '<div class="nv-sr-categories"><h4>Categories</h4><ul>';
      collections.slice(0, 4).forEach(function (c) {
        html += '<li><a href="' + c.url + '">' + c.title + '</a></li>';
      });
      html += '</ul></div>';
    }
    html += '</div>';

    if (merged.length) {
      html += '<div class="nv-sr-right"><h4>Products</h4><div class="nv-sr-pgrid">';
      merged.slice(0, 4).forEach(function (p) {
        var imgTag = p.image
          ? '<span class="nv-sr-card__img"><img src="' + esc(p.image) + '" alt=""></span>'
          : '<span class="nv-sr-card__img nv-sr-card__img--empty"></span>';
        var priceTag = p.priceHtml ? '<span class="nv-sr-card__price">' + esc(p.priceHtml) + '</span>' : '';
        html += '<a class="nv-sr-card" href="' + esc(p.url) + '">' + imgTag + '<span class="nv-sr-card__name">' + esc(p.title) + '</span>' + priceTag + '</a>';
      });
      html += '</div></div>';
    }

    html += '</div>';
    if (term) {
      html += '<a class="nv-sr-seeall" href="/search?q=' + encodeURIComponent(term) + '&type=product">See all results for "' + term + '" →</a>';
    }

    resultsEl.innerHTML = html;
    resultsEl.hidden = false;
  }

  // 2026-10-08: native predictive ranking put last year's stock at the top of this dropdown —
  // searching "christmas" gave Build Your Own Crackers, the Ornament Storage Box and a 2025 paper
  // tree in the only four slots, while the 2026 range was nowhere. Predictive results can't be
  // re-ranked from the storefront, so the new-season pieces are read from the predictive-search
  // SECTION, which already does the ordering (query-matched titles first, then the collection's
  // manual order, colourway siblings collapsed). Keeping that logic in one place is the point —
  // do NOT reimplement the ordering here; only the trigger list below is duplicated, and it must
  // stay in step with sections/predictive-search.liquid and sections/main-search.liquid.
  // Failure is non-fatal: an empty lead just leaves the native results as they were.
  var NV_SEASONAL = /christmas|xmas|bauble|cracker|advent|ribbon/;
  var seasonalCache = {};

  function fetchSeasonalLead(q) {
    if (!NV_SEASONAL.test(q.toLowerCase())) return Promise.resolve([]);
    if (seasonalCache[q]) return Promise.resolve(seasonalCache[q]);
    return fetch('/search/suggest?q=' + encodeURIComponent(q) + '&section_id=predictive-search')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var out = [];
        Array.prototype.forEach.call(doc.querySelectorAll('.ps-card'), function (card) {
          var img = card.querySelector('img');
          var t = card.querySelector('.ps-card__title');
          var pr = card.querySelector('.ps-card__price');
          out.push({
            url: card.getAttribute('href'),
            title: t ? t.textContent.trim() : '',
            image: img ? img.getAttribute('src') : null,
            priceHtml: pr ? pr.textContent.trim() : ''
          });
        });
        seasonalCache[q] = out;
        return out;
      })
      .catch(function () { return []; });
  }

  function fetchSuggestions(q) {
    if (!q || q.length < 2) { resultsEl.hidden = true; return; }
    if (q === lastQ) return;
    lastQ = q;
    var base = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[options][unavailable_products]=last';
    Promise.all([
      fetch(base + '&resources[type]=product&resources[limit]=4').then(function (r) { return r.json(); }),
      fetch(base + '&resources[type]=query,collection&resources[limit]=5').then(function (r) { return r.json(); }),
      fetchSeasonalLead(q)
    ])
    .then(function (parts) {
      renderResults({
        lead: parts[2] || [],
        resources: { results: {
          products:    (parts[0].resources && parts[0].resources.results && parts[0].resources.results.products)    || [],
          queries:     (parts[1].resources && parts[1].resources.results && parts[1].resources.results.queries)     || [],
          collections: (parts[1].resources && parts[1].resources.results && parts[1].resources.results.collections) || []
        }}
      });
    })
    .catch(function () { resultsEl.hidden = true; });
  }

  var doFetch = debounce(function () { fetchSuggestions(input.value.trim()); }, 280);
  input.addEventListener('input', doFetch);

  // Hide results when overlay closes
  document.addEventListener('click', function (e) {
    if (e.target.hasAttribute('data-nv-search-close') || e.target.closest('[data-nv-search-close]')) {
      resultsEl.hidden = true;
      lastQ = '';
    }
    if (e.target.hasAttribute('data-nv-search-open') || e.target.closest('[data-nv-search-open]')) {
      setTimeout(function () { input.focus(); }, 80);
    }
  });

  // Clear on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { resultsEl.hidden = true; lastQ = ''; }
  });
})();
